export default {"src":"/_next/static/media/sw-new-logo.e86a2e7e.svg","height":70,"width":280,"blurWidth":0,"blurHeight":0};